import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useSelector } from "react-redux";
import { isEmptyObject, useOuterClick } from "../../helpers";
import Select from "react-select";
const ProfileFilter = (props) => {
  const [assigneeId, SetAssigeeId] = useState([]);
  const [jobStatus, SetJobStatus] = useState([]);
  const [priority, setPriority] = useState([]);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState("");
  useEffect(() => {
    if (!isEmptyObject(props?.filterData)) {
      if (props?.filterData?.jobStatus) {
        SetJobStatus(props?.filterData?.jobStatus);
        let inputs = document.querySelectorAll('input[name="statusCheckbox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.jobStatus.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
      if (props?.filterData?.assigneeId) {
        SetAssigeeId(props?.filterData?.assigneeId);
      }
      if (props?.filterData?.priority) {
        setPriority(props?.filterData?.priority);
        var inputs = document.querySelectorAll(
          'input[name="priorityCheckbox"]'
        );
        for (var i = 0; i < inputs.length; i++) {
          if (props?.filterData?.priority.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
    } else {
      uncheckAll();
    }
  }, [props?.filterData]);

  const handleFilter = () => {
    let res = {};
    if (assigneeId.length > 0) {
      res["assigneeId"] = assigneeId;
    }
    if (jobStatus.length > 0) {
      res["jobStatus"] = jobStatus;
    }
    if (priority.length > 0) {
      res["priority"] = priority;
    }
    props.hangleFilterOption(res);
    props.setChannelPopover(false);
  };
  const assignData = useSelector((state) => state.jobProfiles.assignee);

  useEffect(() => {
    if (assignData.length > 0) {
      const resVal = assignData.map((val) => {
        return {
          value: val?.id,
          label: val?.name,
        };
      });
      setOptions(resVal);
    }
  }, [assignData]);

  function onChange(option) {
    SetAssigeeId(option ? option.map((item) => item.value) : []);
  }

  const getValue = () => {
    if (options) {
      return assigneeId
        ? options.filter((option) => assigneeId.indexOf(option.value) >= 0)
        : [];
    } else {
      return [];
    }
  };

  const AssigneeChange = (e) => {
    let arr = assigneeId;
    if (
      e.target.value &&
      !assigneeId.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetAssigeeId(arr);
  };

  const jobStChange = (e) => {
    let arr = jobStatus;
    if (
      e.target.value &&
      !jobStatus.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetJobStatus(arr);
  };

  const priorityChange = (e) => {
    let arr = priority;
    if (
      e.target.value &&
      !priority.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    setPriority(arr);
  };

  function uncheckAll() {
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((el) => (el.checked = false));
  }

  const resetFilter = () => {
    SetAssigeeId([]);
    SetJobStatus([]);
    setPriority([]);
    uncheckAll();
    props.setChannelPopover(false);

    props.hangleFilterOption({});
  };

  const innerRef = useOuterClick((e) => {
    if (
      e.target.id !== "filter-button" &&
      e.target?.classList[0] !== "react-select__option" &&
      e.target?.tagName !== "svg"
    ) {
      props.setChannelPopover(false);
    }
  });

  return (
    <>
      <div ref={innerRef}>
        <Accordion allowMultipleExpanded allowZeroExpanded>
          {/* <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>Assigneed</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <ul className="check-list">
              <li className="input-items">
                <input
                  type="checkbox"
                  value="10"
                  name="AssigneeCheckbox"
                  id="AssigneeCheckbox"
                />
                To Me
              </li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem> */}
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Status</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Drafted"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Drafted
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Active"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Active
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Closed"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Closed
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Priority</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Normal"
                    name="priorityCheckbox"
                    onChange={(e) => priorityChange(e)}
                  />
                  Normal
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Medium"
                    name="priorityCheckbox"
                    onChange={(e) => priorityChange(e)}
                  />
                  Medium
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="High"
                    name="priorityCheckbox"
                    onChange={(e) => priorityChange(e)}
                  />
                  High
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Assignee</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  name="assigneeFilter"
                  value={getValue()}
                  onChange={onChange}
                  onInputChange={(value) => setQuery(value)}
                  options={options
                    .filter((x) =>
                      x.label.toLowerCase().includes(query.toLowerCase())
                    )
                    .slice(0, 5)}
                  isMulti={true}
                  placeholder="Select Assignee"
                />
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <div className="button-group">
          <button
            className="proceedBtn"
            onClick={() => {
              handleFilter();
            }}
          >
            Apply
          </button>
          <button
            className="resetBtn"
            onClick={() => {
              resetFilter();
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileFilter;
